export class ContentfulContentRef {
    title: string
    text: string
}
